var _path, _path2, _path3, _path4, _polygon, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 187.09 36.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54,30.09H46.74L54,10.27H38.14L39.86,5.5H24.37L26,.94H0V9.27H14.66L4.72,36.53h8.33l8.27-22.65h7.16L20.21,36.53h8.38l6.5-17.88h7.49L36.09,36.53H49.41l4.27-4.39Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.72,29.64H78l6.94-19.31H65.67a7.19,7.19,0,0,0-6.16,4.44L54,30.09l-.28,2.05c.06,2.17,1.17,4.39,3.06,4.39H64.4L69,31.64c-.12,2.28,1,4.89,3,4.89h7.66l5.38-5.27Zm-16.33-.16h-6.6l4.38-12h6.61L69.39,29.48Z",
    fill: "currentcolor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.14,29.59h-8.33l-2.33-7.5,13.43-12h-9.54L98.54,19.76h-.83L104.7.5H96.32L85.72,29.64l-.62,1.62-1.88,5.27H91.6L96.54,23h.94l4.22,13.55h8.94l5-5.33Z",
    fill: "currentcolor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.57,29.31H125L132.4,9.83h-9l-7.27,19.93-.45,1.61c-.22,2.38,1,5.16,3.06,5.16h11.16l5.16-5.66Z",
    fill: "currentcolor"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "136.18 0 126.96 0 124.19 7.61 133.29 7.61 136.18 0 136.18 0",
    fill: "currentcolor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M154.61,29.31H144.28l5-13h5.27l2.5-6.89h-5.16L155.44,0h-9.16l-3.44,9.38h-6.05l-2.5,6.89h6.05l-4.77,13-.5,1.56c-.45,2.44.78,5.66,3,5.66h11.16l4.83-5.27Z",
    fill: "currentcolor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M154.06,31.09c-.39,2.39.83,5.44,3,5.44h7.66l4.61-4.89c-.11,2.28,1.06,4.89,3.06,4.89h14.71V29.64h-8.77l7-19.31H166a7,7,0,0,0-6.11,4.44l-5.27,14.38Zm15.65-1.61H163.1l4.45-12h6.55l-4.39,12.05Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.d9a38cbc3a7d58c6c88f17fdb54a060e.svg";
export { ForwardRef as ReactComponent };